import { ConfigDataClass } from "./em-common/config/config";

export function PreloadFactory(configService: ConfigDataClass) {
    return () => configService.initialize();
  }